import { createActions } from 'utils/actions';

/**
 * Redux actions for fetching threading documents by thread ID.
 *
 * @type {Object}
 */
export const fetchThreadDocuments = createActions('threadDocuments', 'FETCH_THREAD_DOCUMENTS', {
    asPromise: true,
});

/**
 * Redux actions for fetching insights documents by thread ID.
 *
 * @type {Object}
 */
export const fetchInsightsDocuments = createActions(
    'insightsDocuments',
    'FETCH_INSIGHTS_DOCUMENTS',
    {
        asPromise: true,
    }
);

/**
 * Redux actions for updating new tag for insights
 *
 * @type {Object}
 */
export const updateInsightsNewTag = createActions('insightsDocuments', 'UPDATE_INSIGHTS_NEW_TAG', {
    asPromise: true,
});

/**
 * Redux actions for fetching documents by entry ID for prerview.
 *
 * @type {Object}
 */
export const fetchPreviewDocument = createActions('insightsDocuments', 'FETCH_PREVIEW_DOCUMENT', {
    asPromise: true,
});

/**
 * Redux actions for fetching insights list for a company
 *
 * @type {Object}
 */
export const fetchInsightsList = createActions('insightslist', 'FETCH_INSIGHTS_LIST', {
    asPromise: true,
});

/**
 * Redux actions for fetching insights preview data
 *
 * @type {Object}
 */
export const fetchInsightsPreviewDashboard = createActions(
    'insightPreviewDashboard',
    'FETCH_INSIGHTS_PREVIEW_DASHBOARD',
    {
        asPromise: true,
    }
);

/**
 * Redux actions for fetching insights graph data
 *
 * @type {Object}
 */
export const fetchInsightsGraphDashboard = createActions(
    'insightGraphDashboard',
    'FETCH_INSIGHTS_GRAPH_DASHBOARD',
    {
        asPromise: true,
    }
);
